import { Skeleton, Stack } from "@mui/material"

function VideoSkeleton() {
    return (
        <Stack className="w-full" >
            <Skeleton variant="rounded" height={500} />
            <div className="flex items-center justify-between mt-5">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} className="w-[250px]" />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} className="w-[250px]" />
            </div>
        </Stack >
    )
}

export default VideoSkeleton